import React from 'react';
import BotList from './BotList';

export default function BotControlPage() {
  return (
    <div className="p-4">
      <h1 className="text-3xl font-bold mb-4">Bot Control Page</h1>
      <BotList />
    </div>
  );
}
